/** Tệp bằng chứng đặt hàng trên PI và ảnh yêu cầu sản phẩm / bao bì của khách (yêu cầu v1.8 mục 4.3, 2.3; 11/10/2026). */
export const evidenceEn = {
  piTitle: "Customer order evidence",
  piHint: "The customer's original PO, order photos or screenshots of orders placed in chat. Separate from the Customer PO number above. Visible to whoever can see this PI.",
  drop: "Drag files or photos here, paste a screenshot, or",
  choose: "choose files",
  dropImages: "Drag photos here, paste, or",
  uploading: "Uploading {{count}} file(s)…",
  pending: "Saved with the record",
  open: "Open",
  remove: "Remove",
  empty: "No files yet.",
  badType: "{{name}}: only PNG, JPEG, WEBP, GIF, PDF, Word, Excel or PowerPoint files.",
  badImage: "{{name}}: only PNG, JPEG, WEBP or GIF photos.",
  tooMany: "At most {{max}} files.",
  uploadFailed: "{{name}} could not be uploaded.",
  saveFailed: "The PI was saved, but its order evidence was not. The files are still listed below — press Save again.",
  loadFailed: "The saved files could not be loaded, so this list cannot be changed yet (saving now could drop them).",
  loading: "Loading saved files…",
  listLoadFailed: "The files could not be loaded.",
  reqListLoadFailed: "The requirements could not be loaded.",
  needEditRight: "Attaching files needs the Edit right on proforma invoices.",
  waitUpload: "Wait until the files finish uploading, then save.",
  errUnknown: "The list changed elsewhere since this page was opened. Reload the page and try again.",
  errTaken: "One of the files is already attached to another record.",
  addedBy: "Added {{at}} by {{name}}",
  reqTitle: "Customer product requirements",
  reqHint: "Product, packaging and other requirements of this customer — shown every time the customer is opened. Several entries per category are allowed; each entry keeps its own photos.",
  reqAdd: "Add requirement",
  reqCategory: "Category",
  reqEntryTitle: "Title",
  reqDescription: "Description",
  reqPhotos: "Photos",
  reqRemove: "Remove entry",
  reqEmpty: "No requirements recorded.",
  reqSaveFailed: "The customer was saved, but the product requirements were not. They are still listed below — press Save again.",
  reqLoadFailed: "The saved requirements could not be loaded, so they cannot be changed yet (saving now could drop them).",
  reqLoading: "Loading saved requirements…",
  reqNeedEditRight: "Recording requirements needs the Edit right on customers.",
  reqUpdated: "Updated {{at}} by {{name}}",
  cat_shippingMarks: "Shipping marks",
  cat_packagingDimensions: "Packaging dimensions",
  cat_productLogo: "Product logo",
  cat_packingQuantities: "Packing quantities",
  cat_packagingBags: "Packaging bags",
  cat_outerCartons: "Outer cartons and sacks",
  cat_other: "Other requirements",
  catHint_shippingMarks: "Text, layout, placement and reference photos",
  catHint_packagingDimensions: "Inner and outer packaging dimensions with units",
  catHint_productLogo: "Logo artwork, colours, placement and reference photos",
  catHint_packingQuantities: "Quantity per bag, box or carton",
  catHint_packagingBags: "Bag material, specification, printing and reference photos",
  catHint_outerCartons: "Carton or sack material, specification, packing method and reference photos",
  catHint_other: "Other written instructions and related photos",
};

export const evidenceVi: typeof evidenceEn = {
  piTitle: "Bằng chứng đặt hàng của khách",
  piHint: "PO gốc của khách, ảnh đơn hoặc ảnh chụp đơn đặt qua chat. Tách khỏi ô số PO của khách ở trên. Ai xem được PI này thì xem được các tệp này.",
  drop: "Kéo tệp hoặc ảnh vào đây, dán ảnh chụp màn hình, hoặc",
  choose: "chọn tệp",
  dropImages: "Kéo ảnh vào đây, dán, hoặc",
  uploading: "Đang tải lên {{count}} tệp…",
  pending: "Lưu cùng bản ghi",
  open: "Mở",
  remove: "Bỏ",
  empty: "Chưa có tệp nào.",
  badType: "{{name}}: chỉ nhận PNG, JPEG, WEBP, GIF, PDF, Word, Excel hoặc PowerPoint.",
  badImage: "{{name}}: chỉ nhận ảnh PNG, JPEG, WEBP hoặc GIF.",
  tooMany: "Tối đa {{max}} tệp.",
  uploadFailed: "Không tải lên được {{name}}.",
  saveFailed: "PI đã lưu nhưng tệp bằng chứng đặt hàng chưa lưu. Các tệp vẫn còn ở dưới — bấm Lưu lại.",
  loadFailed: "Không tải được danh sách tệp đã lưu nên chưa sửa được mục này (lưu lúc này có thể làm mất tệp cũ).",
  loading: "Đang tải các tệp đã lưu…",
  listLoadFailed: "Không tải được danh sách tệp.",
  reqListLoadFailed: "Không tải được các yêu cầu.",
  needEditRight: "Đính kèm tệp cần quyền Sửa hoá đơn chiếu lệ.",
  waitUpload: "Chờ tệp tải lên xong rồi hãy lưu.",
  errUnknown: "Danh sách đã bị đổi ở nơi khác từ lúc mở trang. Tải lại trang rồi làm lại.",
  errTaken: "Có tệp đã được đính vào một bản ghi khác.",
  addedBy: "Thêm lúc {{at}} bởi {{name}}",
  reqTitle: "Yêu cầu sản phẩm của khách",
  reqHint: "Yêu cầu về sản phẩm, bao bì và các yêu cầu khác của khách — hiện mỗi lần mở khách. Một nhóm có thể có nhiều mục; mỗi mục giữ ảnh của riêng nó.",
  reqAdd: "Thêm yêu cầu",
  reqCategory: "Nhóm",
  reqEntryTitle: "Tiêu đề",
  reqDescription: "Mô tả",
  reqPhotos: "Ảnh",
  reqRemove: "Bỏ mục",
  reqEmpty: "Chưa ghi yêu cầu nào.",
  reqSaveFailed: "Khách đã lưu nhưng yêu cầu sản phẩm chưa lưu. Các mục vẫn còn ở dưới — bấm Lưu lại.",
  reqLoadFailed: "Không tải được các yêu cầu đã lưu nên chưa sửa được mục này (lưu lúc này có thể làm mất yêu cầu cũ).",
  reqLoading: "Đang tải các yêu cầu đã lưu…",
  reqNeedEditRight: "Ghi yêu cầu cần quyền Sửa khách hàng.",
  reqUpdated: "Sửa lúc {{at}} bởi {{name}}",
  cat_shippingMarks: "Mác vận chuyển",
  cat_packagingDimensions: "Kích thước bao bì",
  cat_productLogo: "Logo sản phẩm",
  cat_packingQuantities: "Số lượng đóng gói",
  cat_packagingBags: "Túi đóng gói",
  cat_outerCartons: "Thùng / bao ngoài",
  cat_other: "Yêu cầu khác",
  catHint_shippingMarks: "Chữ, bố cục, vị trí và ảnh tham chiếu",
  catHint_packagingDimensions: "Kích thước bao bì trong và ngoài kèm đơn vị",
  catHint_productLogo: "File logo, màu, vị trí và ảnh tham chiếu",
  catHint_packingQuantities: "Số lượng mỗi túi, hộp hoặc thùng",
  catHint_packagingBags: "Chất liệu túi, quy cách, in ấn và ảnh tham chiếu",
  catHint_outerCartons: "Chất liệu thùng / bao, quy cách, cách đóng và ảnh tham chiếu",
  catHint_other: "Hướng dẫn khác bằng chữ và ảnh liên quan",
};

export const evidenceZh: typeof evidenceEn = {
  piTitle: "客户订单凭证",
  piHint: "客户原始 PO、订单照片或聊天下单截图。与上方客户 PO 编号分开。能查看此 PI 的人即可查看这些文件。",
  drop: "将文件或照片拖到这里、粘贴截图，或",
  choose: "选择文件",
  dropImages: "将照片拖到这里、粘贴，或",
  uploading: "正在上传 {{count}} 个文件…",
  pending: "随记录一起保存",
  open: "打开",
  remove: "移除",
  empty: "尚无文件。",
  badType: "{{name}}：只接受 PNG、JPEG、WEBP、GIF、PDF、Word、Excel 或 PowerPoint 文件。",
  badImage: "{{name}}：只接受 PNG、JPEG、WEBP 或 GIF 照片。",
  tooMany: "最多 {{max}} 个文件。",
  uploadFailed: "{{name}} 上传失败。",
  saveFailed: "PI 已保存，但订单凭证未保存。文件仍列在下方，请再次保存。",
  loadFailed: "无法载入已保存的文件，暂时不能修改此栏（现在保存可能会丢失原有文件）。",
  loading: "正在载入已保存的文件…",
  listLoadFailed: "无法载入文件列表。",
  reqListLoadFailed: "无法载入产品要求。",
  needEditRight: "上传附件需要形式发票的编辑权限。",
  waitUpload: "请等待文件上传完成后再保存。",
  errUnknown: "打开此页后，列表已在别处被修改。请刷新页面后重试。",
  errTaken: "有文件已附加到另一条记录。",
  addedBy: "{{name}} 于 {{at}} 添加",
  reqTitle: "客户产品要求",
  reqHint: "该客户对产品、包装及其他方面的要求——每次打开客户都会显示。同一类别可有多条；每条保留各自的照片。",
  reqAdd: "新增要求",
  reqCategory: "类别",
  reqEntryTitle: "标题",
  reqDescription: "说明",
  reqPhotos: "照片",
  reqRemove: "删除此条",
  reqEmpty: "尚未记录要求。",
  reqSaveFailed: "客户已保存，但产品要求未保存。要求仍列在下方，请再次保存。",
  reqLoadFailed: "无法载入已保存的要求，暂时不能修改（现在保存可能会丢失原有要求）。",
  reqLoading: "正在载入已保存的要求…",
  reqNeedEditRight: "记录产品要求需要客户的编辑权限。",
  reqUpdated: "{{name}} 于 {{at}} 修改",
  cat_shippingMarks: "唛头",
  cat_packagingDimensions: "包装尺寸",
  cat_productLogo: "产品标志",
  cat_packingQuantities: "包装数量",
  cat_packagingBags: "包装袋",
  cat_outerCartons: "外箱及编织袋",
  cat_other: "其他要求",
  catHint_shippingMarks: "文字、版式、位置及参考照片",
  catHint_packagingDimensions: "内外包装尺寸及单位",
  catHint_productLogo: "标志图稿、颜色、位置及参考照片",
  catHint_packingQuantities: "每袋、每盒或每箱数量",
  catHint_packagingBags: "袋子材质、规格、印刷及参考照片",
  catHint_outerCartons: "纸箱或编织袋材质、规格、包装方式及参考照片",
  catHint_other: "其他文字说明及相关照片",
};
